<template>
    <div :class="['alert-' + type]">
        <slot></slot>
    </div>
</template>

<script setup>
const props     = defineProps({
    type    : {
        type    : String,
        default : 'success',
    },

    showIcon: {
        type    : Boolean,
        default : false,
    },

    icon    : {
        type    : String,
        default : '',
    }
});

</script>

<style scoped lang="scss">
    .alert-success {
        @apply bg-green-600 text-white text-base py-3 px-3 my-4 rounded-lg;
    }

    .alert-info {
        @apply bg-blue-500 text-white text-base py-3 px-3 my-4 rounded-lg;
    }

    .alert-warning {
        @apply bg-yellow-600 text-white text-base py-3 px-3 my-4 rounded-lg;
    }

    .alert-error {
        @apply bg-red-500 text-white text-base py-3 px-3 my-4 rounded-lg;
    }

</style>